import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyAlxxyYsO3OpncNmRWgtN2MRzyUP-yOBrs",
  authDomain: "akaina-dev.firebaseapp.com",
  projectId: "akaina-dev",
  storageBucket: "akaina-dev.appspot.com",
  messagingSenderId: "794308403852",
  appId: "1:794308403852:web:4b07cf921d5dc251ef11a9",
  measurementId: "G-NYN4CLF0QP",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
export const db = getFirestore(app);

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);
